export const STATUS_CODES = {
    // success
    SUCCESS: 200,
    SUCCESS_POST: 201,
    SUCCESS_NO_CONTENT: 204,
    // error
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    VALIDATION_ERROR: 422,
    INTERNAL_ERROR: 500,
};

export const STATUS_MSG = {
    AUTH_SERVICE_STATUS_SUCCESS_MSG: "ok",
    AUTH_SERVICE_HEALTH_CHECK_SUCCESS_MG: "green",
};

export const ERROR_TITLE = {
    INTERNAL_ERROR: "Oops. Something went wrong!",
};

// SUCCESS AND ERROR
export const SUCCESS_MSG = {
    SUCCESS_TITLE: "Success!",
    SUCCESS_TEXT: "Your changes have been saved.",
};

export const ERROR_MSG = {
    INTERNAL_ERROR_TITLE: "Something went wrong!",
    INTERNAL_ERROR_MSG: "Please contact your administrator.",
    INTERNAL_CONNECTION_TIMEOUT: "Connection timeout. Please try again.",
    INTERNAL_ERROR: "Something went wrong! Please contact your administrator.",
    AUTH_SERVICE_404_MSG: "Invalid or Expired Link.",
    AUTH_SERVICE_403_MSG: "Invalid current password",
    TIMEOUT_EXCEEDED: "timeout of 30000ms exceeded",
    INACTIVE_USER: "Sorry. Your account is not active.",
};

export const TOKEN_ERR = {
    EXPIRED: "Authorization token has expired!",
    INVALID: "Authorization token is invalid!",
    TELSTRA_TOKEN_EXPIRED: "Access Token expired",
};

// SOCIAL CLUB CONTENT TYPE
export const CONTENT_TYPE = {
    POST: "POST",
    COMMENT: "COMMENT",
};

// USER CLUB CONTENT STATUS
export const CONTENT_STATUS = {
    APPROVED: "A",
    DISAPPROVED: "I",
    PENDING: "P",
};

export const TOKEN = {
    EXPIRY: 86400000, // 24 hours
};

export const SUBSCRIPTION_PERIOD = {
    P1Y: "1 Years",
    P2Y: "2 Years",
    P3Y: "3 Years",
    P4Y: "4 Years",
    P5Y: "5 Years",
};

export const USER_ROLE = {
    SUPER_ADMIN: "SADM",
    USER_ADMIN: "LADM",
    USER: "CUST",
    WALK: "WALK",
    SITT: "SITT",
    WASI: "WASI",
    // all user except SADM and LADM
    ALL_CUST: "ALL_CUST",
};

export const USER_TYPE = {
    CUST: "Customer",
    WALK: "Walker",
    SITT: "Sitter",
    WASI: "Walker and Sitter",
    BRDER: "Breeder",
};

// TRANSACTION STATUS
export const TRANSACTION_STATUS = {
    FOR_DELIVERY: "For delivery",
    OUT_FOR_DELIVERY: "Out for delivery",
    REQUEST_CANCELLATION: "For cancellation",
    CANCELLED: "Cancelled",
    REFUNDED: "Refunded",
    DELIVERED: "Delivered",
    FAILED: "FAILED",
    PICKED_UP: "Picked up",
};

// TRANSACTION STATUS
export const DOG_PURCHASE_STATUS = {
    PR: "PENDING REQUEST",
    A: "APPROVED",
    DA: "DISAPPROVED",
    DISAPPROVED_REFUND: 'DISAPPROVED REFUND',
    CR: "CANCELLED REQUEST",
    PP: "PENDING PAYMENT",
    FP: "FOR PICKUP",
    RR: "REQUEST FOR REFUND",
    CP: "CANCELLED PURCHASE",
    R: "REFUNDED",
    PU: "PICKED UP",
    F: "FAILED",
    D: "DELIVERED",
};

// Period List
export const PAYMENT_FREQUENCY_DISPLAY = {
    P1M: "Monthly",
    P3M: "Quarterly",
    P12M: "Yearly",
};

export const LIST = {
    SIZEGROUPLIST: [
        {
            id: 1,
            name: "Toy",
        },
        {
            id: 2,
            name: "Small",
        },
        {
            id: 3,
            name: "Medium",
        },
        {
            id: 4,
            name: "Large",
        },
        {
            id: 5,
            name: "Extra Large",
        },
    ],
    RECIPIENTLIST: [
        {
            id: "ALL",
            name: "All",
        },
        {
            id: "BREEDS",
            name: "Breed",
        },
        {
            id: "PET_AGE",
            name: "Age Group",
        },
        {
            id: "BREED_SIZE",
            name: "Size Group",
        },
        {
            id: "CUSTOMER",
            name: "Customer",
        },
        {
            id: "BREEDER",
            name: "Breeder",
        }
    ],
    RECIPIENTLISTAGE: [
        {
            id: "ALL",
            name: "All",
        },
        {
            id: "BREEDS",
            name: "Breed",
        },
        {
            id: "BREED_SIZE",
            name: "Size Group",
        },
    ],
    YEARLIST: [
        {
            id: "0",
            name: "0",
        },
        {
            id: "1",
            name: "1",
        },
        {
            id: "2",
            name: "2",
        },
        {
            id: "3",
            name: "3",
        },
        {
            id: "4",
            name: "4",
        },
        {
            id: "5",
            name: "5",
        },
        {
            id: "6",
            name: "6",
        },
        {
            id: "7",
            name: "7",
        },
        {
            id: "8",
            name: "8",
        },
        {
            id: "9",
            name: "9",
        },
        {
            id: "10",
            name: "10",
        },
        {
            id: "11",
            name: "11",
        },
        {
            id: "12",
            name: "12",
        },
        {
            id: "13",
            name: "13",
        },
        {
            id: "14",
            name: "14",
        },
        {
            id: "15",
            name: "15",
        },
        {
            id: "16",
            name: "16",
        },
        {
            id: "17",
            name: "17",
        },
        {
            id: "18",
            name: "18",
        },
        {
            id: "19",
            name: "19",
        },
        {
            id: "20",
            name: "20",
        },
    ],
    MONTHLISTWITHZERO: [
        {
            id: "0",
            name: "0",
        },
        {
            id: "1",
            name: "1",
        },
        {
            id: "2",
            name: "2",
        },
        {
            id: "3",
            name: "3",
        },
        {
            id: "4",
            name: "4",
        },
        {
            id: "5",
            name: "5",
        },
        {
            id: "6",
            name: "6",
        },
        {
            id: "7",
            name: "7",
        },
        {
            id: "8",
            name: "8",
        },
        {
            id: "9",
            name: "9",
        },
        {
            id: "10",
            name: "10",
        },
        {
            id: "11",
            name: "11",
        },
    ],
    MONTHLIST: [
        {
            id: "1",
            name: "1",
        },
        {
            id: "2",
            name: "2",
        },
        {
            id: "3",
            name: "3",
        },
        {
            id: "4",
            name: "4",
        },
        {
            id: "5",
            name: "5",
        },
        {
            id: "6",
            name: "6",
        },
        {
            id: "7",
            name: "7",
        },
        {
            id: "8",
            name: "8",
        },
        {
            id: "9",
            name: "9",
        },
        {
            id: "10",
            name: "10",
        },
        {
            id: "11",
            name: "11",
        },
    ],
};

// STATUS
export const STATUS = {
    A: "APPROVED",
    P: "PENDING",
    C: "CANCEL",
    R: "REMOVED",
    DA: "DISAPPROVED",
    I: "CANCEL",
};

// DOG ORDER STATUS
export const DOG_ORDER_STATUS = {
    PENDING: "Dog order is pending",
    "For pickup": "Dog order is ready for pickup",
    FAILED: "Dog order is failed",
    "For cancellation": "Client requested for cancellation",
    Cancelled: "Approved dog order cancellation",
    P: "Requested dog purchased is pending for approval",
    A: "Requested dog purchased is approved",
    "Picked up": "Dog has been picked up by the customer",
    Delivered: "Dog has been delivered",
    Refunded: "Refunded",
};

// STATES
export const STATES = {
    ACT: "Australian Capital Territory",
    NSW: "New South Wales",
    NT: "Northern Territory",
    QLD: "Queensland",
    SA: "South Australia",
    TAS: "Tasmania",
    VIC: "Victoria",
    WA: "Western Australia",
};

//PUPPY SELL STATUS
export const PUPPY_SELL_STATUS = {
    P: "PENDING",
    A: "AVAILABLE",
    S: "SOLD",
    D: "DECLINED",
    F: "FAILED",
    DISAPPROVED_REFUND: 'DISAPPROVED REFUND',
    REQUEST_REFUND: "REQUEST FOR REFUND",
    CANCELED: "CANCELLED",
    REFUNDED: "REFUNDED",
    PICKED_UP: "PICKED UP",
    DELETED: "DELETED",
    PENDING_PAYMENT: "PENDING PAYMENT",
    HIDDEN: "HIDDEN"
};

//BREEDER STATUS
export const BREEDER_STATUS = {
    P: "PENDING",
    A: "ACTIVE",
    D: "DELETED",
    DECLINED: "DECLINED",
    DEACTIVATED: "DEACTIVATED",
    FOR_REACTIVATION: "FOR REACTIVATION",
};

export const BREEDER_STATUS_LIST = [
    { id: 'ACTIVE', name: 'ACTIVE' },
    { id: 'DELETED', name: 'DELETED' },
    { id: 'DECLINED', name: 'DECLINED' },
    { id: 'DEACTIVATED', name: 'DEACTIVATED' },
    { id: 'FOR_REACTIVATION', name: 'FOR REACTIVATION' }
];

export const SUBSCRIPTION_STATUS = {
	A: "ACTIVE",
    I: "INACTIVE",
	CANCELLED: "CANCELLED",
	FOR_CANCELLATION: "FOR_CANCELLATION",
	ENDED: "ENDED",
	DELETED: "DELETED",
    DISAPPROVED_CANCELLATION: "DISAPPROVED_CANCELLATION",
    APPROVED_CANCELLATION: "APPROVED_CANCELLATION",
}

export const PRODUCT_STATUS = {
    INACTIVE : "I",
    ACTIVE : "A",
}

export const WHELPING_DATE_STATUS = {
	ACTIVE: "ACTIVE",
	DELETED: "DELETED",
}

export const LITTER_STATUS = {
	ACTIVE: "ACTIVE",
	DELETED: "DELETED",
}